import React from 'react';
import styled, { css } from 'styled-components';
import MiniCalendar from '@pages/Calendar/MiniCalendar/MiniCalendar';
import { MAIN_HOME_SEC_TYPE } from '@typings/setting/MainHomeSecType';
import HomeNoticeSec from '@pages/MainHome/HomeNoticeSec';
import BoxBannerSec from '@pages/MainHome/BannerSec/BoxBannerSec';
import CumuNotice from '@template/CumuNotice/CumuNotice';
import MainhomeMusicPlayer from '@template/MusicPlayer/MainhomeMusicPlayer/MainhomeMusicPlayer';
import MiniGuestbook from '@pages/GuestBook/Miniguestbook';
import MasterInfo from '@template/MasterInfo';
import UserInfoSec from '@template/User/UserInfo/UserInfoSec';
import { useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';
import { useRecoilValue } from 'recoil';
import { layoutTypeState } from '@atom/setting/homepageSet';
import { LAYOUT_TYPE, LAYOUT_TYPE_VALUE } from '@typings/setting/layoutType';
import { scrollbarHide } from '@styles/variants/scrollbar';
import CurrentDocs from '@template/CurrentDocs/CurrentDocs';
import DdayWidget from '@template/Widget/DdayWidget';
import TextColck from '@template/TextColck';
import DailyTodoList from '@template/DailyTodo/DailyTodoList';

const layoutMap = {
  [LAYOUT_TYPE.THREEDAN]: css`
    padding: 24px 0;
  `,

  [LAYOUT_TYPE.MEMO]: css`
    padding: 16px;
  `,

  [LAYOUT_TYPE.BLOG]: css`
    position: sticky;
    top: 0;
    padding: 24px 0;
    height: 100vh;
    overflow-y: auto;
    ${scrollbarHide}
  `,
};

const containerLayoutMap = {
  [LAYOUT_TYPE.MEMO]: css`
    max-height: calc(90dvh - 80px);
  `,
  [LAYOUT_TYPE.BLOG]: css`
    height: fit-content;
  `,
  [LAYOUT_TYPE.THREEDAN]: css`
    max-height: 90vh;
  `,
  [LAYOUT_TYPE.LEFT]: css`
    max-height: 90vh;
  `,
  [LAYOUT_TYPE.MINIHOME]: css`
    max-height: 90vh;
  `,
  [LAYOUT_TYPE.TOP]: css`
    max-height: 90vh;
  `,
  [LAYOUT_TYPE.UNSET]: css`
    max-height: 90vh;
  `,
};

const drawMap = {
  [LAYOUT_TYPE.MEMO]: css`
    backdrop-filter: unset;
    border-radius: unset;
    background-color: unset;
    padding: unset;
    border: unset;
  `,
};

const Wrapper = styled.div`
  grid-area: aside;
  z-index: 0;
  padding: 16px;
`;

const Container = styled.div<{
  layoutType?: LAYOUT_TYPE_VALUE;
}>`
  /* safari , mobile vh문제 해결 */
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  height: auto;
  overflow-y: auto;
  ${scrollbarHide}

  ${({ layoutType }) => layoutType && containerLayoutMap[layoutType]};
`;
const Component = styled.div<{
  layoutType?: LAYOUT_TYPE_VALUE;
}>`
  max-height: 300px;
  padding: 0;
  border-radius: var(--cardBorderRadius);
  background: var(--backgroundColor);
  backdrop-filter: blur(12px);
  border: 1px solid var(--lineColor);
  height: fit-content;
  overflow-y: auto;
  ${scrollbarHide}

  ${({ layoutType }) => layoutType && drawMap[layoutType]}
`;
type Props = {
  style?: React.CSSProperties;
};
function Aside({ style }: Props) {
  const layoutType = useRecoilValue(layoutTypeState);
  const { data, set } = useDocument<any>(
    `${CollectionPath.MAINHOME}/${ImainhomeDoc.ASIDE}`,
    { listen: true },
  );

  const items = Array.isArray(data?.list)
    ? data!.list
    : data?.list
      ? Object.values(data.list)
      : [];

  const MAIN_HOME_SEC_COMPONENT_MAP = {
    [MAIN_HOME_SEC_TYPE.MINICALENDAR]: <MiniCalendar />,
    [MAIN_HOME_SEC_TYPE.USERLOGIN]: <UserInfoSec />,
    [MAIN_HOME_SEC_TYPE.DDAYWIDGHET]: <DdayWidget />,
    [MAIN_HOME_SEC_TYPE.MASTERINFO]: <MasterInfo />,
    [MAIN_HOME_SEC_TYPE.GUESTBOOK]: <MiniGuestbook />,
    [MAIN_HOME_SEC_TYPE.CLOCK]: <TextColck />,
    [MAIN_HOME_SEC_TYPE.DAILYTODO]: <DailyTodoList />,
  };

  return (
    <Wrapper style={{ ...style }}>
      <Container layoutType={layoutType}>
        {items &&
          items
            .filter((item: any) => item && item.isShow)
            .map((item: any, i: number) => {
              const _Component = MAIN_HOME_SEC_COMPONENT_MAP[item.key];

              if (item.key === MAIN_HOME_SEC_TYPE.POSTINGNOTICE) {
                return <CumuNotice key={item.key} type="default" />;
              }
              if (item.key === MAIN_HOME_SEC_TYPE.LATEST) {
                return <CurrentDocs key={item.key} maxHeight="300px" />;
              }
              if (item.key === MAIN_HOME_SEC_TYPE.MUSICPLAYER) {
                return <MainhomeMusicPlayer key={item.key} size="sm" />;
              }
              if (item.key === MAIN_HOME_SEC_TYPE.NOTICE) {
                return <HomeNoticeSec key={item.key} />;
              }
              if (item.key === MAIN_HOME_SEC_TYPE.BANNEER) {
                return <BoxBannerSec key={item.key} />;
              }

              if (_Component) {
                return (
                  <Component key={item.key} layoutType={layoutType}>
                    {_Component}
                  </Component>
                );
              }
              return null;
            })}
      </Container>
    </Wrapper>
  );
}

export default Aside;
